<template>
  <div class="pcb-products-list">
    <h3 class="h4">{{ kind }}</h3>
    <transition-group name="list" tag="div" class="pcb-products-grid f fw" appear>
      <pcb-product-card
        v-for="product in products"
        :key="product.id"
        :product="product"
        :quantity="getQuantityFor(product)"
      />

      <div key="bundle-link" v-if="showUpsellBox && upsellCard" class="pcb-product-card pcb-upsell-card">
        <div class="wrapper w1">
          <div class="title h2" v-html="upsellCard.premade_bundle_title"></div>
          <p class="p2" v-html="upsellCard.premade_bundle_content"></p>
          <a :href="upsellCard.premade_bundle_link" class="btn btn--primary btn--wider">
            <span class="button__el" v-html="upsellCard.premade_bundle_cta"></span>
          </a>

          <div class="upsell-image ratio ro-2">
            <vue-image
              :src="upsellCard.premade_bundle_image"
              :size="650"
              css="fit-contain"
            />
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import PcbProductCard from 'modules/pcb-product-card/pcb-product-card.vue'
import scrollMonitor from 'scrollmonitor'

export default {
  props: [
    'kind',
    'products',
    'bundle',
    'showUpsellBox'
  ],
  components: {
    PcbProductCard
  },
  mounted () {
    this.watcher = scrollMonitor.create(this.$el, -1 * window.innerHeight * 0.5)
    this.watcher.enterViewport(this.onEnterView)
  },
  computed: {
    upsellCard () {
      return window.HU.premade_bundle_upsell || null
    }
  },
  methods: {
    onEnterView () {
      this.$emit('in-view', this.kind)
    },
    getQuantityFor (product) {
      return this.bundle[product.id] ? this.bundle[product.id] : 0
    }
  },
  beforeDestroy () {
    if (this.watcher) this.watcher.destroy()
  }
}
</script>
